import React from 'react';
import { history } from '../../services/routing';

export function HtmlContent({ children, ...props }) {
  const handleClick = e => {
    const href = e.target.getAttribute('href');
    if (href && href.startsWith('/')) {
      e.preventDefault();
      history.push(href);
    }
  };
  return (
    <span
      {...props}
      onClick={handleClick}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}
